import { OAuthStorage } from "angular-oauth2-oidc";

export class PrefixedOAuthStorageService extends OAuthStorage {
  constructor(
    private storage: any,
    private prefix: string,
    private showDebugInformation: boolean = false,
  ) {
    super();
  }

  private buildKey(key: string): string {
    return `${this.prefix}/${key}`;
  }

  override getItem(key: string): string | null {
    return this.storage.getItem(this.buildKey(key));
  }
  override removeItem(key: string): void {
    if (this.showDebugInformation) {
      console.warn(`prefixed-oauth-storage: Key ${key} removed`);
    }
    this.storage.removeItem(this.buildKey(key));
  }
  override setItem(key: string, data: string): void {
    if (this.showDebugInformation) {
      console.warn(`prefixed-oauth-storage: Key ${key} set with ${data}`);
    }
    this.storage.setItem(this.buildKey(key), data);
  }
}
